import {
  root,
  inputs
} from './01.constant.mjs';

import {
  debug,
  setModality,
  setCustomScrollEvent
} from './02.util.mjs';

import './04.jquery.extension.mjs';

import {
  Cssvar,
  Scroll,
  Darkmode,
  Language,
  Header,
  Offcanvas,
  OffcanvasEvent,
  Form,
  Fieldset,
  Input,
  Choice,
  Button,
  ButtonQuantity,
  Datetimer,
  Autocomplete,
  Toast,
  Dialog,
  DialogAddress,
  Table,
  Tab,
  Card,
  Tooltip,
  Footnote,
  DetailsDeepLink,
  FooterDoormat,
  Lightbox,
  Loading,
  BackToTop,
  NewsTicker
} from './05.class.mjs';

import {
  Book,
  Locations,
  Insurance,
  Support,
  Faq,
  Signup,
  Log,
  MyProfile,
  Legal,
  MyBookingArrival,
  MyBookingControl,
  MyBookingInquiry,
  ContactUs,
  HomeCover,
  HomeBanner
} from './06.class.page.mjs';

/*==============================================================*/
// 전역 노출 설정 (가장 먼저 실행되도록 최상단에 배치)
/*==============================================================*/
window.Dialog = Dialog;

/*==============================================================*/
// * 인덱스에서 defer 속성으로 script.min.js 파일을 로딩하기 때문에
// * 아래 DOMContentLoaded 굳이 불요하나 안전망 구축 위해 유지
// * 순서 : (1) 페이지 레이아웃 관련, (2) 공통 컴포넌트, (3) 세부 페이지
/*==============================================================*/

document.addEventListener('DOMContentLoaded', () => {
  setModality(); // input method to html[data-modality]
  setCustomScrollEvent(); // custom scroll events: scrollup|down|(up|down)stop

  new Darkmode('[data-toggle-darkmode]').watch();
  new Language('select[data-select-language]').watch();
  new Header('body > header').watch();
  new Offcanvas('button[data-toggle-offcanvas]').watch();
  new OffcanvasEvent('button[data-toggle-offcanvas]').watch();

  new Table().watch();

  new Form().watch();
  new Fieldset().watch();
  new Input().watch();
  new Choice(
    'label.label > input[type=checkbox], label.label > input[type=radio]'
  ).watch();
  new Button('.button').watch();
  new ButtonQuantity().watch();
  new Datetimer().watch();
  new Autocomplete().watch();
  new DialogAddress().watch();

  new Tab('[data-tab]').watch();
  new Card('.cards').watch();
  new Tooltip('[data-tooltip]').watch();
  new Footnote(
    'a[id^="footnote-ref"], ol.footnotes a[href^="#footnote-ref"]'
  ).watch();

  new DetailsDeepLink().watch();
  new FooterDoormat().watch();
  new Lightbox().watch();
  new BackToTop('[data-back-to-top]').watch();

  new NewsTicker().watch();

  //// CLASS @ PAGE ////
  new Book().watch();

  new Insurance.Coverage().watch();
  new Insurance.ClaimForm().watch();

  new Support().watch();
  new Faq().watch();

  new Signup().watch();
  new Log().watch();
  new MyProfile().watch();
  new Legal().watch();

  new MyBookingArrival().watch();
  new MyBookingControl().watch();
  new MyBookingInquiry().watch();

  new ContactUs().watch();

  new HomeCover().watch();
  new HomeBanner().watch();

  Dialog.watch(); // * new 없음 주의!

  // ? 해당 페이지(locations/index.php)에만 window.LOCATION_DATA가 존재하므로
  if ( window.LOCATION_DATA ) new Locations(window.LOCATION_DATA).watch();
});

// * CSS required: 모든 렌더링이 끝난 후 트랜지션이 활성화
// * - DOMContentLoaded 이벤트 : DOM 트리 완성 시점
// * - load 이벤트 : 이미지, 스타일시트 등 모든 리소스가 완전히 로드된 시점
// * - 별도 클래스화 필요 없음
window.addEventListener('load', () => {
  root.removeAttribute('data-page-loading');
  Loading.hide();
});